<template>
  <div class="w-100">
    <div class="d-none d-lg-inline-block mb-4 w-100">
      <div class="d-flex justify-content-center">
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
      </div>
    </div>
    <div class="d-inline-block d-lg-none mb-4 w-100">
      <div class="d-flex justify-content-center">
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
        <b-img class="title-aster" src="/static/images/aster_green_tiny.png"></b-img>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AsterRow'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/AsterRow.vue